export type StepKeyAOW =
    | 'merchantInformation'
    | 'addMidsVarsheets'
    | 'reviewAndSubmit'
    | 'merchantHandOff';

export type StepStatus = 'pending' | 'inProgress' | 'completed';

export interface StepState {
    step: StepKeyAOW;
    status: StepStatus;
    updatedAt: string | null;
    updatedBy: string | null;
}

export interface StepStateAOW {
    step: StepKeyAOW;
    status: StepStatus;
    updatedAt: string | null;
    updatedBy: string | null;
}

export interface AcquireOnboardingStatusResponse {
    onboardingId: number;
    fdClientId: string;
    createdBy: string;
    steps: StepState[];
}

export const STEP_ORDER_AOW: StepKeyAOW[] = [
    'merchantInformation',
    'addMidsVarsheets',
    'reviewAndSubmit',
    'merchantHandOff',
];

export const STEP_LABELS_AOW: Record<StepKeyAOW, { title: string; subtitle?: string }> = {
    merchantInformation: { title: "Step 1", subtitle: 'Merchant Information' },
    addMidsVarsheets: { title: 'Step 2', subtitle: 'Add MIDs/VAR sheets' },
    reviewAndSubmit: { title: 'Step 3', subtitle: 'Review and Submit' },
    merchantHandOff: { title: 'Step 4', subtitle: 'Merchant handoff' },
};

export const STEP_PATH_AOW: Record<StepKeyAOW, string> = {
    merchantInformation: 'client-data-review',
    addMidsVarsheets: 'mids',
    reviewAndSubmit: 'review-submit',
    merchantHandOff: 'merchant-handoff',
};

/** Query param carrying the selected merchant onboarding id in AOW routes. */
export const MERCHANT_ID_QUERY_PARAM = 'merchantId';

export interface ApiStepperItem {
    id: number;
    step: string;
    status: 'inProgress' | 'pending' | 'completed';
    onboardingId: number;
    createdAt: string;
    updatedAt: string;
    stepName: string;
};

export interface ApiStepperResponse {
    message: string;
    result: ApiStepperItem[];
};

export const STEP_FROM_NUMBER_AOW: Record<number, StepKeyAOW> = {
    1: 'merchantInformation',
    2: 'addMidsVarsheets',
    3: 'reviewAndSubmit',
    4: 'merchantHandOff',
};
export const NUMBER_FROM_STEP_AOW: Record<StepKeyAOW, number> = {
    merchantInformation: 1,
    addMidsVarsheets: 2,
    reviewAndSubmit: 3,
    merchantHandOff: 4,
};
